export const CHART_COLORS = ['hsl(var(--primary))', '#22c55e', '#3b82f6', '#f59e0b', '#ef4444'];
